
export default function header(
	state = { selectedKey: null },
	action
) {
	if (action.type === "click") {
		return { selectedKey: "0" }
	}
	else if (action.type === "CLICK_0") {
	   return { selectedKey: "0" }
	 }
	else if (action.type === "CLICK_1") {
		return { selectedKey: "1" }
	}
	else if (action.type === "CLICK_2") {
		return { selectedKey: "2" }
	}
	else if (action.type === "CLICKLANDING_0") {
		 return { selectedKey: "0" }
	 }
	else if (action.type === "CLICKLANDING_1") {
		return { selectedKey: "1" }
	}
	else if (action.type === "CLICKLANDING_2") {
		return { selectedKey: "2" }
	}
	else if (action.type === "CLICKLANDING_3") {
		 return { selectedKey: "3" }
	 }
	else if (action.type === "CLICKLANDING_4") {
		return { selectedKey: "4" }
	}
	else if (action.type === "CLICKLANDING_5") {
		return { selectedKey: "5" }
	}
  else {
		return state;
	}
}
